/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
import {
  Col,
  Row,
  ModalFooter,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Card,
  CardHeader,
  CardBody,
} from 'reactstrap';
import { useEffect, useState, useRef } from 'react';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { Form } from '@unform/web';
import axios from 'axios';
import qs from 'qs';
import { bBoxAspectRatio, calculateSize, SizeType } from 'bbox-aspect-ratio';
import { FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';
import selectBody from './selectBody';
import api from '../../services/api';
import { Select, Input } from '../../components/unform/index';
import { Timeline } from '../../components';
import { Translator } from '../../components/i18n';

const instance = axios.create({
  baseURL: 'https://services.sentinel-hub.com',
});

const config = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
  },
};

const bodyToken = qs.stringify({
  client_id: '798fde30-5a5f-4e2d-8fe5-161047ecc2fc',
  client_secret: 'xf@f/h~HarkxqTbWr|?L7#VJ(bqlu[u2S>WW(5iB',
  grant_type: 'client_credentials',
});

function SentinelHub({ modalSentinel, toggleModalSentinel, selectedtalhao }) {
  const obrigatorio = Translator({
    path: 'obrigatorio',
  });
  const erroBuscaDados = Translator({
    path: 'erroBuscaDados',
  });
  const infosSatelite = Translator({
    path: 'infosSatelite',
  });
  const levarSegundos = Translator({
    path: 'levarSegundos',
  });
  const sentinelRef = useRef(null);
  const [selectedBbox, setSelectedBbox] = useState([]);
  const [selectedPolygon, setSelectedPolygon] = useState(null);
  const [images, setImages] = useState(null);
  const [imgViewer, setImgViewer] = useState(false);
  // const [tipoSatelite, setTipoSatelite] = useState(null);

  async function getBbox() {
    if (
      selectedtalhao?.length &&
      selectedtalhao?.length <= 1 &&
      modalSentinel === true
    ) {
      Swal.fire({
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      try {
        // const body = {
        //   ids_talhao: selectedtalhao,
        // };

        // const { data } = await api.post('/talhaoes-sentinel', body);

        const { data } = await api.get(`/talhao/${selectedtalhao[0]}`);
        setSelectedPolygon(data?.talhao?.objeto[0]?.features[0]?.geometry);

        // console.log(data);
        // setSelectedPolygon(data?.talhao?.objeto[0]?.features);
        setSelectedBbox(data?.bounds);

        Swal.close();
      } catch (err) {
        toast.error(erroBuscaDados);
        Swal.close();
      }
    }
  }

  async function handleSubmit(data) {
    const errors = {};
    Object.keys(data).forEach((f) => {
      if (!data[f]) {
        errors[f] = obrigatorio;
      }
    });

    sentinelRef.current.setErrors(errors);

    if (!Object.keys(errors).length) {
      Swal.fire({
        title: infosSatelite,
        html: levarSegundos,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      try {
        await instance.post('/oauth/token', bodyToken, config).then((resp) => {
          Object.assign(instance.defaults, {
            headers: { authorization: `Bearer ${resp.data.access_token}` },
          });
        });

        const bodyCatalog = {
          bbox: selectedBbox,
          datetime: `${data?.data_inicio}T00:00:00Z/${data?.data_fim}T23:59:59Z`,
          collections:
            data?.satelite === 'sentinel_S2L1C'
              ? ['sentinel-2-l1c']
              : ['sentinel-2-l2a'],
          limit: 100,
          fields: {
            exclude: ['id', 'type', 'geometry', 'bbox', 'links', 'assets'],
          },
        };

        const { data: datasCatalogo } = await instance.post(
          'https://services.sentinel-hub.com/api/v1/catalog/search',
          bodyCatalog
        );

        const topRight = [selectedBbox[0], selectedBbox[1]];
        const bottomLeft = [selectedBbox[2], selectedBbox[3]];

        const aspectRatio = bBoxAspectRatio([...topRight, ...bottomLeft]);

        const width = 300;
        const sizeByWidth = calculateSize(aspectRatio, width, SizeType.Width);

        const height = sizeByWidth;

        const imagens = [];

        const periodo =
          (new Date(data?.data_fim) - new Date(data?.data_inicio)) / 8.64e7;

        const defaultDias = {};
        Array.from({ length: periodo + 1 }, (_, i) => i).forEach((i) => {
          const dia = new Date(`${data?.data_inicio}T00:00`).setDate(
            new Date(`${data?.data_inicio}T00:00`).getDate() + i
          );

          defaultDias[new Date(dia).toISOString().split('T')[0]] = false;
        });

        const dias = datasCatalogo?.features
          ?.reverse()
          ?.reduce((result, obj) => {
            const [date] = obj.properties.datetime.split('T');
            if (!result[date]) {
              result[date] = true;
            }

            return result;
          }, defaultDias);

        for await (const [dia, consultar] of Object.entries(dias)) {
          if (!consultar) {
            imagens.push({
              data: dia.split('-').reverse().join('/'),
              imagem: false,
            });
            continue;
          }

          const body = selectBody({
            dataInicio: dia,
            dataFim: dia,
            satelite: data?.satelite,
            tipo: data?.tipo,
            selectedBbox,
            selectedPolygon,
            width,
            height,
          });

          const { data: resp } = await instance.post(
            data?.satelite === 'sentinel_S2L1C' ||
              data?.satelite === 'sentinel_S2L2A'
              ? 'https://services.sentinel-hub.com/api/v1/process'
              : 'https://services-uswest2.sentinel-hub.com/api/v1/process',
            body,
            { responseType: 'arraybuffer' }
          );

          const base64ImageString = Buffer.from(resp, 'binary').toString(
            'base64'
          );

          imagens.push({
            data: dia.split('-').reverse().join('/'),
            imagem: `data:image/png;base64,${base64ImageString}`,
          });
        }

        setImages(imagens);
        Swal.close();
      } catch (err) {
        toast.error(erroBuscaDados);
        Swal.close();
      }
    }
  }

  useEffect(() => {
    getBbox();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedtalhao, modalSentinel]);

  return (
    <>
      <Modal isOpen={modalSentinel} toggle={toggleModalSentinel} size="md">
        <ModalHeader toggle={toggleModalSentinel}>Sentinel Hub</ModalHeader>
        <ModalBody>
          <Form ref={sentinelRef} onSubmit={(data) => handleSubmit(data)}>
            <Row>
              <Col lg={6}>
                <Select
                  label={<Translator path="mapa.sentinelHub.satelite" />}
                  className="form-control"
                  name="satelite"
                  // onChange={(e) => setTipoSatelite(e?.target?.value)}
                  data={[
                    {
                      label: Translator({
                        path: 'fazenda.upload.selecione',
                      }),
                      value: '',
                    },
                    {
                      label: 'Sentinel 2 S2L1C',
                      value: 'sentinel_S2L1C',
                    },
                    {
                      label: 'Sentinel 2 S2L2A',
                      value: 'sentinel_S2L2A',
                    },
                    // {
                    //   label: 'Landsat 8-9',
                    //   value: 'landsat',
                    // },
                  ]}
                />
              </Col>
              <Col lg={6}>
                <Select
                  label={<Translator path="mapa.sentinelHub.tipo" />}
                  className="form-control"
                  name="tipo"
                  data={[
                    {
                      label: Translator({
                        path: 'fazenda.upload.selecione',
                      }),
                      value: '',
                    },
                    {
                      label: 'True Color',
                      value: 'true_color',
                    },
                    {
                      label: 'Moisture index',
                      value: 'moisture',
                    },
                    {
                      label: 'Agriculture',
                      value: 'agriculture',
                    },
                    {
                      label: 'NDVI',
                      value: 'ndvi',
                    },
                    {
                      label: 'SWIR',
                      value: 'swir',
                    },
                    {
                      label: 'NWDI',
                      value: 'nwdi',
                    },
                    {
                      label: 'NDSI',
                      value: 'ndsi',
                    },
                    {
                      label: 'NDMI',
                      value: 'ndmi',
                    },
                  ]}
                />
              </Col>
              <Col lg={4}>
                <Input
                  name="data_inicio"
                  label={<Translator path="mapa.sentinelHub.datainicio" />}
                  className="form-control"
                  type="date"
                />
              </Col>
              <Col lg={4}>
                <Input
                  name="data_fim"
                  label={<Translator path="mapa.sentinelHub.datafim" />}
                  className="form-control"
                  type="date"
                />
              </Col>
              <Col lg={4}>
                <label className="mb-2">&nbsp;</label>
                <Button block type="submit" className="btn">
                  <Translator path="mapa.sentinelHub.btnvisualizar" />
                </Button>
              </Col>
            </Row>
          </Form>
          <hr />
          <Row
            style={{ maxHeight: 550, overflowY: 'auto', overflowX: 'hidden' }}
          >
            <Timeline
              data={images || []}
              titleKey="data"
              customContent={(i, index) =>
                i?.imagem ? (
                  <button
                    type="button"
                    onClick={() => setImgViewer({ index })}
                    className="border-none bg-transparent shadow-low"
                  >
                    <img src={i?.imagem} alt="SentinelHub" width={60} />
                  </button>
                ) : (
                  <h6>
                    <Translator path="sentinelHub.semimagem" />
                  </h6>
                )
              }
            />
          </Row>
        </ModalBody>
        <ModalFooter />
      </Modal>

      <div
        style={{
          backgroundColor: 'rgba(0,0,0,0.8)',
          position: 'absolute',
          left: 0,
          bottom: 0,
          top: 0,
          right: 0,
          zIndex: 10000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        hidden={!imgViewer}
      >
        <button
          type="button"
          style={{
            position: 'absolute',
            top: 10,
            right: 10,
            backgroundColor: 'transparent',
            border: 'none',
          }}
          onClick={() => setImgViewer(false)}
        >
          <FaTimes size={30} color="#fff" />
        </button>
        <div>
          <h5
            style={{
              color: '#fff',
              textAlign: 'center',
            }}
          >
            {images?.[imgViewer?.index]?.data}
          </h5>
          <img
            src={images?.[imgViewer?.index]?.imagem}
            alt="SentinelHub"
            style={{
              width: '87vw',
              height: '87vh',
              objectFit: 'contain',
            }}
          />
          <div className="d-flex justify-content-center mt-3">
            <a
              download="download.png"
              className="btn btn-primary"
              href={images?.[imgViewer?.index]?.imagem}
            >
              Download
            </a>
          </div>
        </div>
        <button
          type="button"
          style={{
            position: 'absolute',
            top: '50%',
            bottom: '50%',
            width: 30,
            height: 30,
            left: 10,
            backgroundColor: 'transparent',
            border: 'none',
          }}
          onClick={() => {
            const imgs = images.filter((f) => f.imagem);
            const imgIndex = imgs.indexOf(images[imgViewer?.index]);
            let curr = imgIndex - 1;

            if (imgIndex === 0) {
              curr = imgs.length - 1;
            }

            setImgViewer({ index: images.indexOf(imgs[curr]) });
          }}
        >
          <FaChevronLeft size={30} color="#fff" />
        </button>
        <button
          type="button"
          style={{
            position: 'absolute',
            top: '50%',
            bottom: '50%',
            width: 30,
            height: 30,
            right: 10,
            backgroundColor: 'transparent',
            border: 'none',
          }}
          onClick={() => {
            const imgs = images.filter((f) => f.imagem);
            const imgIndex = imgs.indexOf(images[imgViewer?.index]);
            let curr = imgIndex + 1;

            if (imgIndex === imgs.length - 1) {
              curr = 0;
            }

            setImgViewer({ index: images.indexOf(imgs[curr]) });
          }}
        >
          <FaChevronRight size={30} color="#fff" />
        </button>
      </div>
    </>
  );
}

export default SentinelHub;
